import {
  FilterSearchAndSelect,
  type FilterSearchOptions,
  ROLES,
  useRoleCheck,
} from "@pharmupp/p3-front-commons"

export const PostListFilterSection = ({
  rubrics,
  statuses,
  creatorTypes,
}: {
  rubrics: FilterSearchOptions
  statuses: FilterSearchOptions
  creatorTypes: FilterSearchOptions
}) => {
  const isAdmin = useRoleCheck(ROLES.ADMIN)
  return (
    <>
      {!!isAdmin && (
        <FilterSearchAndSelect name="rubric" label="Rubrique" options={rubrics} />
      )}
      <FilterSearchAndSelect name="status" label="Statut" options={statuses} />
      {!!isAdmin && (
        <FilterSearchAndSelect
          name="creatorTypes"
          label="Source info"
          options={creatorTypes}
        />
      )}
    </>
  )
}
